import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// For whatever reason, it is important that the 'OrganizationEditPage' is imported before the 'SharedModule'
import { OrganizationEditPage } from 'src/app/organization/organization-edit/organization-edit.page';
import { SharedModule } from 'src/app/@shared/shared.module';

const routes: Routes = [
  {
    component: OrganizationEditPage,
    path: '',
  },
];

@NgModule({
  declarations: [OrganizationEditPage],
  imports: [RouterModule.forChild(routes), SharedModule],
})
export class OrganizationEditPageModule {}
